<template>
  <span>
    {{ $t("SCORECARDS.PTS_RANGE") }}
  </span>

  <div class="flex items-center justify-between">
    <input
      v-for="(_, index) in modelValue"
      :key="index"
      v-model="value[Number(index)]"
      class="h-9 w-16 rounded-sm border border-gray-300"
      type="number"
      @blur="handlePtsBlur(Number(index))"
    />
  </div>

  <lf-slider v-model="value" :min="min" :max="max" :disabled="!max" />

  <span v-if="!max" class="text-red-500">
    {{ $t("SCORECARDS.NO_POINTS_AVAILABLE") }}
  </span>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

import LfSlider from "../ui/LfSlider.vue";

import type { PropType } from "vue";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: Object as PropType<[number, number]>,
    required: true,
  },
  min: {
    type: Number as PropType<number>,
    required: true,
  },
  max: {
    type: Number as PropType<number>,
    required: true,
  },
});

const value = ref(props.modelValue);

const handlePtsBlur = (index: number) => {
  const isStringType = typeof value.value[index] === "string";
  const shouldChangeVal =
    (index === 0 && value.value[0] >= value.value[1]) ||
    (index === 1 && value.value[1] <= value.value[0]);

  if (!isStringType && !shouldChangeVal) {
    return;
  }

  value.value[index] = index === 0 ? 0 : props.max;
};

watch(value, (newVal) => {
  emit("update:modelValue", newVal);
});
</script>

<style scoped>
@reference "@/assets/tailwind.css";

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  @apply appearance-none;
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
